import { isEmpty, prop } from "lodash/fp";
import { padEnd } from "lodash";

//从地址的区编码获取省和市的编码
function splitCode(county) {
  if (isEmpty(county)) {
    return [];
  }
  return [padEnd(county.slice(0, 2), 6, 0), padEnd(county.slice(0, 4), 6, 0)];
}

//从地址的区编码获取地址 省/市/区
export function parseAddress(county, areaMap) {
  if (isEmpty(county) || isEmpty(areaMap)) {
    return "";
  }
  const [province, city] = splitCode(county);
  const { city_list, province_list, county_list } = areaMap;
  const res = [
    prop(province)(province_list),
    prop(city)(city_list),
    prop(county)(county_list),
  ].join("/");
 
  return res;
}

 

// 生成签名
export function signature({ areaCode, gradeCode, sexCode, phone, name, accessKey } = {}){
  const base = `areaCode=${areaCode}&gradeCode=${gradeCode}&sexCode=${sexCode}&phone=${phone}&name=${name}&accessKey=${accessKey}`;
  console.log(base)
  const s = encodeURIComponent(base)
  console.log(s.replaceAll('%',''))
  return btoa(s.replaceAll('%',''));
}
 